module.exports = __webpack_public_path__ + "img/neckline length.9f5aaf6e.png";